import { compress } from "micro-graphql-react"

export default compress`
  mutation($id: ID!) {
    unpublishTutor(id: $id) {
      published
    }
  }
`
